import '~/assets/scss/mobileapp.scss'


import getSwiperSlider from '~/js/modules/slider';

window.addEventListener('DOMContentLoaded', () => {

  /*Слайдер*/
  const mobileappSlider = document.querySelector('.mobileapp__slider');

  if (mobileappSlider) {
    let mobileappSwiper;

    const mobileappSwiperParams = {
      slidesPerView: 'auto',
      loop: false,
      autoplay: false,
      navigation: false,
      pagination: false,
    };

    mobileappSwiper = getSwiperSlider(mobileappSlider, mobileappSwiperParams);

    if (window.innerWidth >= 1024) {
      if (mobileappSwiper.initialized) {
        mobileappSwiper.destroy();
      }
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) {
        if (mobileappSwiper.initialized) {
          mobileappSwiper.destroy();
        }
      } else {
        if (!mobileappSwiper.initialized) {
          mobileappSwiper = getSwiperSlider(mobileappSlider, mobileappSwiperParams);
        }
      }
    });
  }
});
